import React, { useState, useEffect } from 'react';

const FontLoader = ({ children }) => {
  const [fontLoaded, setFontLoaded] = useState(false);

  useEffect(() => {
    document.fonts.load('1rem "Forma DJR UI"').then(() => {
      setFontLoaded(true);
    });
  }, []);

  if (!fontLoaded) {
    return null; // Or a loading spinner
  }

  return <>{children}</>;
};

export default FontLoader;
